import { getBankBranchListData, getBankListData } from '../libs/apis/BankApi';

export const GET_BANK_LIST_REQUEST = 'GET_BANK_LIST_REQUEST';
export const GET_BANK_LIST_SUCCESS = 'GET_BANK_LIST_SUCCESS';
export const GET_BANK_LIST_FAILURE = 'GET_BANK_LIST_FAILURE';

export const GET_BANK_BRANCH_LIST_REQUEST = 'GET_BANK_BRANCH_LIST_REQUEST';
export const GET_BANK_BRANCH_LIST_SUCCESS = 'GET_BANK_BRANCH_LIST_SUCCESS';
export const GET_BANK_BRANCH_LIST_FAILURE = 'GET_BANK_BRANCH_LIST_FAILURE';

export const getBankList = params => dispatch => {
  dispatch({ type: GET_BANK_LIST_REQUEST });
  return getBankListData(params)
    .then(response =>
      dispatch({
        type: GET_BANK_LIST_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_BANK_LIST_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getBankBranchList = params => dispatch => {
  dispatch({ type: GET_BANK_BRANCH_LIST_REQUEST });
  return getBankBranchListData(params)
    .then(response =>
      dispatch({
        type: GET_BANK_BRANCH_LIST_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_BANK_BRANCH_LIST_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
